import {
  GET_ASSIGNED_APPOINTMENTS,
  GET_CONFIRMED_APPOINTMENTS,
  CONFIRM_APPOINTMENT,
  RESCHEDULE_APPOINTMENT,
  MOVE_BACK_QUEUE,
  GET_AVAILABLE_SLOTS,
  DOCTOR_ASSIGN,
  REMOVE_APPOINTMENT,
} from "../types/AssignedAppointmentTypes";

import {
  getAssignedAppointments,
  confirmAppointment,
  rescheduleAppointment,
  moveBackToQueue,
  getAvailableTimeSlots,
  doctorAssign,
  getConfirmedAppointments,
  removeAppointment,
} from "../../services/AssignedAppointmentService";

import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Fetch assigned (booked - unconfirmed) appointments
export function getAssignedAppointmentAction(payload) {
  return async (dispatch) => {
    try {
      const res = await getAssignedAppointments(payload);

      if (res?.status === 200 && res.data?.status === "success") {
        dispatch({
          type: GET_ASSIGNED_APPOINTMENTS,
          payload: res.data.data,
        });
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to load assigned appointments");
    }
  };
}

// Fetch confirmed appointments grouped by time slots
export function getConfirmedAction(payload) {
  return async (dispatch) => {
    try {
      const res = await getConfirmedAppointments(payload);

      if (res?.status === 200 && res.data?.status === "success") {
        dispatch({
          type: GET_CONFIRMED_APPOINTMENTS,
          // payload: res.data.data,
          payload: {
            data: res.data.data,
            summary: res.data.summary,
          },
        });
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to fetch confirmed appointments");
    }
  };
}

export function getAvailableSlotsAction(payload) {
  return async (dispatch) => {
    try {
      const res = await getAvailableTimeSlots(payload);

      if (res?.status === 200 && res.data?.status === "success") {

        // ✅ Send FULL slot objects to Redux
        dispatch({
          type: GET_AVAILABLE_SLOTS,
          payload: res.data.data || [],
        });

        // ✅ Return response (optional but useful)
        return res;
      }

    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to load time slots");
    }
  };
}
// Assign doctor to appointment
export function doctorAssignAction(data) {
  return async (dispatch) => {
    try {
      const res = await doctorAssign(data);

      if (res?.status === 200 && res.data?.status === "success") {
        dispatch({
          type: DOCTOR_ASSIGN,
          payload: data,
        });

        handleSuccess("Doctor assigned successfully");
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to assign doctor");
    }
  };
}

// Confirm appointment
export function confirmAppointmentAction(data) {
  return async (dispatch) => {
    try {
      const res = await confirmAppointment(data);

      if (res?.status === 200 && res.data?.status === "success") {
        dispatch({
          type: CONFIRM_APPOINTMENT,
          payload: data,
        });
        handleSuccess("Appointment confirmed successfully");
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to confirm appointment");
    }
  };
}

// Reschedule appointment
export function rescheduleAppointmentAction(data) {
  return async (dispatch) => {
    try {
      const res = await rescheduleAppointment(data);

      if (res?.status === 200 && res.data?.status === "success") {
        dispatch({
          type: RESCHEDULE_APPOINTMENT,
          payload: data,
        });
        handleSuccess("Appointment rescheduled successfully");
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to reschedule appointment");
    }
  };
}

// Remove appointment
export function removeAppointmentAction(appointmentId) {
  return async (dispatch) => {
    try {
      const res = await removeAppointment(appointmentId);

      if (res?.status === 200 && res.data?.status === "success") {
        dispatch({
          type: REMOVE_APPOINTMENT,
          payload: appointmentId,
        });
        handleSuccess("Appointment removed successfully");
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to remove appointment");
    }
  };
}

// Move back to queue
export function moveBackToQueueAction(appointmentId) {
  return async (dispatch) => {
    try {
      const res = await moveBackToQueue(appointmentId);

      if (res?.status === 200 && res.data?.status === "success") {
        dispatch({
          type: MOVE_BACK_QUEUE,
          payload: appointmentId,
        });
        handleSuccess("Appointment moved back to queue");
      }
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to move appointment back to queue");
    }
  };
}
